import { render } from "./SignUpView.vue?vue&type=template&id=450475ba&scoped=true"
import script from "./SignUpView.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpView.vue?vue&type=script&setup=true&lang=js"

import "./SignUpView.vue?vue&type=style&index=0&id=450475ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450475ba"],['__file',"src/views/auth/SignUpView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "450475ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('450475ba', __exports__)) {
    api.reload('450475ba', __exports__)
  }
  
  module.hot.accept("./SignUpView.vue?vue&type=template&id=450475ba&scoped=true", () => {
    api.rerender('450475ba', render)
  })

}


export default __exports__